export const loggedUserRoutes = {
  main: "/",
  ordersTable: "/orders-table",
};

export const unloggedUserRoutes = {
  login: "/",
  register: "/register",
};
